var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FileGrid"},_vm._l((_vm.content),function(file){return _c('FileGridItem',{key:file._id,attrs:{"content":file},on:{"content-clicked":_vm.contentClicked}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }